<script setup>
import { inject } from 'vue'
import { loc } from '@/__core__/localization/localization'
import Sprite from '@/__core__/components/sprite/Sprite.vue'

defineProps({
  jerseyData: Object,
})

const status = inject('status')
const langId = inject('langId', '')

function getShirtImage(params) {
  let baseImage = "jersey-set/jersey-basic"

  if (!params) return baseImage

  const {
    stripes,
    horizontalStripes,
    squares,
    split,
  } = params


  if (stripes) baseImage = "jersey-set/jersey-vertical-stripes"
  else if (horizontalStripes) baseImage = "jersey-set/jersey-horizontal-stripes"
  else if (squares) baseImage = "jersey-set/jersey-squares"
  else if (split) baseImage = "jersey-set/jersey-split"

  return baseImage
}

const defaultPalet = {
  base: 'grey',
  sleeve: 'grey',
  sleeveDetail: 'grey',
  squaresColor: 'grey'
}

</script>

<template>
  <template v-if="status === 'loading'">
    <div
      class="szw-flex szw-bg-latest-background-color-secondary szw-rounded-2 szw-justify-between szw-items-center szw-p-1 szw-border szw-border-border szw-border-solid">
      <div class="szw-flex szw-flex-col szw-justify-center szw-h-[80px] szw-gap-1 szw-px-1 szw-pt-1">
        <div class="szw-w-[140px] szw-bg-section-static szw-h-[16px] szw-rounded-1 szw-animate-pulse"></div>
        <div class="szw-w-[100px] szw-bg-section-static szw-h-[14px] szw-rounded-1 szw-animate-pulse"></div>
      </div>
      <div class="szw-flex szw-justify-center szw-items-center szw-w-[100px]">
        <sprite sprite-id="jersey-set/jersey-basic" class="szw-z-10 szw-w-full" :color-palet="defaultPalet"/>
        <sprite sprite-id="jersey-set/jersey-basic" class="-szw-ml-[24px] szw-z-0 szw-w-full" :color-palet="defaultPalet"/>
      </div>
    </div>
  </template>

  <template v-if="status === 'success'">
    <div
      class="szw-flex szw-bg-latest-background-color-secondary szw-rounded-2 szw-justify-between szw-items-center szw-p-1 szw-border szw-border-border szw-border-solid">
      <div class="szw-flex szw-flex-col szw-justify-center szw-h-[80px] szw-gap-1 szw-px-1">
        <div class="szw-font-medium szw-text-xs szw-leading-[16px]">{{ loc('sm_player_jersey', langId) }}</div>
        <div class="szw-font-light szw-text-[12px] szw-leading-[14px]"> {{ loc('sm_home', langId) }} / {{ loc('sm_away',
          langId) }}</div>
      </div>
      <div class="szw-flex szw-justify-center szw-items-center szw-w-[100px]">
        <sprite :sprite-id="getShirtImage(jerseyData.home)" class="szw-z-10 szw-w-full" :color-palet="jerseyData?.home || defaultPalet" />
        <sprite :sprite-id="getShirtImage(jerseyData.away)" class="-szw-ml-[24px] szw-z-0 szw-w-full" :color-palet="jerseyData?.away || defaultPalet" />
      </div>
    </div>
  </template>
</template>
